import React from "react"
// import { useLoginContext } from "./useLoginContext"
// import Translate from "service/Translate"
import UserInfoLoggedIn from "./UserInfoLoggedIn"
import { Link } from "react-router-dom"
import Translate from "service/Translate";
// import { Link } from "react-router-dom"

const tn: Translate = Translate.getInstance();
const PanelPageLogoName = () => {
  // const tn: Translate = Translate.getInstance()
  // const context = useLoginContext()
  return (
    <div className="muni-topgroup muni-menu-top-group">
      <Link
       className="muni-logo-group"
        to={
          tn.getLanguage() === "SE"
            ? "/panel/article/sa-funkar-det"
            : "/panel/article/get-started-in-varannan-vecka/"
        }
        style={{ textDecoration: "none", }}
      >
        <img
          className="muni-logo"
          src="https://kommun.varannanvecka.app/wp-content/uploads/2021/03/VV-symbol.svg"
          alt="Varannan Vecka"
        />
        <div style={{flex:1}}>
          <span className="muni-vvname">
            Varannan
            <br />
            Vecka
          </span>
          
        </div>
      </Link>
      <UserInfoLoggedIn />
    </div>
  )
}
export default PanelPageLogoName
